export enum KhotcoinTransactionTypeEnum {
  TOP_UP = 'TOP_UP',
  BOT_FEE = 'BOT_FEE',
  INSURANCE = 'INSURANCE',
}
